import { Box, FormControl, FormControlLabel, InputLabel, 
        OutlinedInput, Radio, RadioGroup, Select } from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers"


export const SelectCustom = (props) => {
  const {children, className,id,label,labelId,value,onChange,idBox=1} = props
  return (
    <Box mt={2} className={className} id={idBox}>
      <FormControl>
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
            labelId={labelId}
            input={<OutlinedInput label={label} />}
            id={id}
            value={value}
            onChange={onChange}>
            {children}
          </Select>
      </FormControl>
    </Box>
  )
}

export const DatePickerCustom = (props) => {
  const {idBox, id, label, format, value, onChange, minDate, maxDate} = props
  return (
    <Box mt={2} id={idBox}>
      <DatePicker
        id={id}
        label={label}
        format={format}
        value={value}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}/>
    </Box>
  )
}

export const RadioGroupCustom = (props) => {
  const {period, onPeriodChange, aviablePeriods} = props
  return (
    <RadioGroup value={period} onChange={onPeriodChange}>
      {aviablePeriods.map(({id, label}) => (
        <FormControlLabel
          key={id}
          value={id}
          control={<Radio />}
          label={label}
          className={`period_${id.toLocaleLowerCase()}`}
        />
      ))}
    </RadioGroup>
  )
}

